module.exports = {"prices":[]}


//////////////////
// WEBPACK FOOTER
// ./config/exports/prices/parking/DSA.json
// module id = 130
// module chunks = 119